var _rect, _mask, _rect2, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaceholderAdImage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 813,
    height: 610,
    viewBox: "0 0 813 610",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 813,
    height: 610,
    fill: "#E2E8F0"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_101_13548",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 231,
    y: 173,
    width: 352,
    height: 264,
    rx: 2
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 231,
    y: 173,
    width: 352,
    height: 264,
    rx: 2,
    stroke: "white",
    strokeWidth: 16,
    mask: "url(#path-2-inside-1_101_13548)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M388.375 316.375H424.625V330.875C424.625 332.798 423.861 334.642 422.502 336.002C421.142 337.361 419.298 338.125 417.375 338.125H395.625C393.702 338.125 391.858 337.361 390.498 336.002C389.139 334.642 388.375 332.798 388.375 330.875V316.375Z",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M406.5 294.625C406.5 288.857 404.208 283.324 400.13 279.245C396.051 275.167 390.518 272.875 384.75 272.875H373.875V280.125C373.875 285.893 376.167 291.426 380.245 295.505C384.324 299.583 389.857 301.875 395.625 301.875H406.5",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M406.5 301.875C406.5 296.107 408.792 290.574 412.87 286.495C416.949 282.417 422.482 280.125 428.25 280.125H439.125V283.75C439.125 289.518 436.833 295.051 432.755 299.13C428.676 303.208 423.143 305.5 417.375 305.5H406.5",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M406.5 316.375V294.625",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderAdImage);
export default __webpack_public_path__ + "static/media/placeholder_ad_image.293b2f25619de50a5c03410b66e805a5.svg";
export { ForwardRef as ReactComponent };